import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/835b90e7-15d7-47fb-a5b4-0e6c183bf516.png" 
                alt="CerviShield" 
                className="h-12 w-12 object-contain"
              />
              <span className="text-2xl font-bold font-display">CerviShield</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              AI-assisted cervical health awareness platform for early risk understanding and preventive healthcare access.
            </p>
            <a 
              href="https://www.linkedin.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-300 cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold mb-6 text-white uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/awareness" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Awareness</Link></li>
              <li><Link to="/prevention" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Prevention Guide</Link></li>
              <li><Link to="/hospital-directory" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Find Hospitals</Link></li>
              <li><Link to="/emergency" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Emergency</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-bold mb-6 text-white uppercase tracking-wider">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/data-insights" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Data Insights</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">About Project</Link></li>
              <li><Link to="/faq" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">FAQ</Link></li>
            </ul>
          </div>

          {/* Health Tools */}
          <div>
            <h3 className="text-sm font-bold mb-6 text-white uppercase tracking-wider">Health Tools</h3>
            <ul className="space-y-3">
              <li><Link to="/health-check" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Risk Assessment</Link></li>
              <li><Link to="/consent" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Get Started</Link></li>
              <li><Link to="/next-steps" className="text-white/80 hover:text-white transition-colors duration-300 text-sm cursor-pointer hover:translate-x-1 inline-block">Next Steps</Link></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/20 pt-8 mb-8">
          <div className="flex items-start gap-3 bg-white/5 rounded-lg p-4">
            <i className="ri-shield-cross-line text-2xl text-white/90 flex-shrink-0 mt-1"></i>
            <p className="text-white/70 text-sm leading-relaxed">
              This platform provides educational guidance only and does not replace professional medical advice. Always consult with qualified healthcare providers for diagnosis and treatment.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20 bg-black/10">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              © 2024 CerviShield. All rights reserved.
            </p>
            <div className="flex items-center gap-2">
              <span className="text-white/60 text-sm">Created by</span>
              <span className="text-white text-lg font-bold tracking-wide">Sarthak Bobade</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
